import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import LogoSVG from '../../components/LogoSVG';

export default function ClientEnter() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');
  const [nameFocus, setNameFocus] = useState(false);
  const [pwFocus, setPwFocus] = useState(false);
  const [hasPassword, setHasPassword] = useState(false);
  const [linkValid, setLinkValid] = useState(true);

  useEffect(() => {
    const savedName = localStorage.getItem('client_name');
    const savedPassword = localStorage.getItem('client_password');
    if (savedName) { setName(savedName); setPassword(savedPassword || ''); setRemember(true); }

    if (token) {
      axios.get(`/api/sharelinks/index.php?token=${token}`)
        .then(res => setHasPassword(res.data.has_password))
        .catch(() => setLinkValid(false));
    }
  }, [token]);

  const handleEnter = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const res = await axios.post('/api/client/enter.php', { token, name, password }, { withCredentials: true });
      if (remember) {
        localStorage.setItem('client_name', name);
        localStorage.setItem('client_password', password);
      } else {
        localStorage.removeItem('client_name');
        localStorage.removeItem('client_password');
      }
      if (res.data.type === 'video') {
        navigate(`/client/viewer/${res.data.target_id}`, { state: { clientName: name } });
      } else {
        navigate('/client/folder', { state: { clientName: name } });
      }
    } catch (err) {
      setError(err.response?.data?.error || '입장에 실패했습니다');
    }
  };

  const inputStyle = (focused) => ({
    ...s.input,
    borderColor: focused ? '#5755df' : 'rgba(255,255,255,0.1)',
    background: focused ? 'rgba(87,85,223,0.08)' : 'rgba(255,255,255,0.06)',
  });

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <div style={s.logoArea}>
          <LogoSVG size={72} />
          <p style={s.subtitle}>영상을 확인하려면<br/>아래 정보를 입력해주세요</p>
        </div>
        {!linkValid && <p style={s.error}>유효하지 않은 링크입니다.</p>}
        <form onSubmit={handleEnter} style={s.form}>
          <div style={s.field}>
            <label style={s.label}>이름</label>
            <input style={inputStyle(nameFocus)} type="text" placeholder="이름을 입력하세요" autoFocus value={name}
              onChange={e => setName(e.target.value)}
              onFocus={() => setNameFocus(true)}
              onBlur={() => setNameFocus(false)} />
          </div>
          {hasPassword && (
            <div style={s.field}>
              <label style={s.label}>비밀번호</label>
              <input style={inputStyle(pwFocus)} type="password" placeholder="제공받은 번호를 입력하세요" value={password}
                onChange={e => setPassword(e.target.value)}
                onFocus={() => setPwFocus(true)}
                onBlur={() => setPwFocus(false)} />
            </div>
          )}
          <label style={s.checkRow}>
            <input type="checkbox" checked={remember} onChange={e => setRemember(e.target.checked)} style={{ width: 15, height: 15, accentColor: '#5755df', cursor: 'pointer' }} />
            <span style={s.checkLabel}>이름 및 비밀번호 저장</span>
          </label>
          {error && <p style={s.error}>{error}</p>}
          <button style={s.btn} type="submit"
            onMouseEnter={e => e.currentTarget.style.background = '#4644c8'}
            onMouseLeave={e => e.currentTarget.style.background = '#5755df'}>
            입장하기
          </button>
        </form>
      </div>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: '#191919', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Pretendard', sans-serif" },
  card: { background: '#1e2740', border: '0.56px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '40px 36px', width: '100%', maxWidth: 360, boxShadow: '0 24px 60px rgba(0,0,0,0.4)' },
  logoArea: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, marginBottom: 28 },
  subtitle: { fontSize: '12pt', color: 'rgba(255,255,255,0.4)', textAlign: 'center', lineHeight: 1.6, margin: 0 },
  form: { display: 'flex', flexDirection: 'column', gap: 0 },
  field: { marginBottom: 14 },
  label: { display: 'block', fontSize: '11pt', color: 'rgba(255,255,255,0.45)', marginBottom: 6 },
  input: { width: '100%', border: '1px solid', borderRadius: 10, padding: '11px 14px', fontSize: '11pt', color: '#fff', outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box', transition: 'border-color .2s, background .2s' },
  checkRow: { display: 'flex', alignItems: 'center', gap: 8, marginTop: 6, cursor: 'pointer' },
  checkLabel: { fontSize: '11pt', color: 'rgba(255,255,255,0.35)' },
  error: { color: '#ff6b6b', fontSize: '10pt', margin: '10px 0 0' },
  btn: { width: '100%', background: '#5755df', border: 'none', borderRadius: 10, padding: '12px', fontSize: '12pt', fontWeight: 600, color: '#fff', cursor: 'pointer', fontFamily: 'inherit', marginTop: 20, transition: 'background .2s' },
};
